import { render, staticRenderFns } from "./AgnosticLocaleSelector.vue?vue&type=template&id=1c3ed394"
import script from "./AgnosticLocaleSelector.vue?vue&type=script&lang=js"
export * from "./AgnosticLocaleSelector.vue?vue&type=script&lang=js"
import style0 from "./AgnosticLocaleSelector.vue?vue&type=style&index=0&id=1c3ed394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports